// src/components/AspirantometroCard.js
import React, { useState, useEffect, useCallback } from 'react';

// Função para calcular dias restantes e porcentagem
const calculateTimeRemaining = (targetDateStr) => {
  // A data alvo é esperada no formato YYYY-MM-DD
  const targetDate = new Date(targetDateStr + 'T12:00:00Z'); // Assumindo meio-dia UTC para evitar problemas de fuso
  const now = new Date();
  
  // Calcula a diferença em milissegundos
  const diffTime = targetDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays <= 0) {
    return {
      diasRestantes: 0,
      porcentagem: 100,
      status: 'Concluído'
    };
  }

  // Define uma data de início (pode ser ajustada para o início do CFO)
  // Assumiremos uma janela de 4 anos (~1460 dias) para o cálculo da porcentagem
  // NOTA: É uma simplificação. O cálculo de dias *restantes* é preciso.
  const TOTAL_DIAS_CFO = 1460; 

  const diasPassados = TOTAL_DIAS_CFO - diffDays;
  const porcentagem = Math.min(100, Math.round((diasPassados / TOTAL_DIAS_CFO) * 100));
  
  return {
    diasRestantes: diffDays,
    porcentagem: porcentagem,
    status: 'Em Andamento'
  };
};


export const AspirantometroCard = ({ aspirantometro }) => {
    const { titulo, data_final } = aspirantometro;
    const [timeData, setTimeData] = useState(calculateTimeRemaining(data_final));

    // Atualiza a cada segundo (opcional, pode ser a cada hora/minuto)
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeData(calculateTimeRemaining(data_final));
        }, 60000); // Atualiza a cada 1 minuto (60000 ms)

        return () => clearInterval(timer);
    }, [data_final]);

    const { diasRestantes, porcentagem, status } = timeData;
    
    // Cores: se concluído, usa cinza. Senão, usa o azul padrão.
    const circleColor = status === 'Concluído' ? 'text-gray-300' : 'text-blue-500';
    const textColor = status === 'Concluído' ? 'text-gray-500' : 'text-blue-600';
    
    // Calcula o offset do círculo (CSS Trick para Doughnut Chart)
    // Stroke-dasharray é a circunferência total. Stroke-dashoffset é o quanto "falta".
    const radius = 40; // Raio do círculo
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (porcentagem / 100) * circumference;

    return (
        <div className="w-full bg-white rounded-xl shadow-lg p-6 flex flex-col items-center justify-center transition-shadow hover:shadow-xl">
            <h3 className="text-lg font-semibold text-gray-700 mb-4 text-center truncate">{titulo}</h3>
            
            <div className="relative h-24 w-24 mb-4">
                <svg className="w-full h-full transform -rotate-90">
                    {/* Fundo do círculo (Cinza claro) */}
                    <circle 
                        className="text-gray-200"
                        strokeWidth="8"
                        stroke="currentColor"
                        fill="transparent"
                        r={radius}
                        cx="50%"
                        cy="50%"
                    />
                    {/* Círculo de progresso (Cor dinâmica) */}
                    <circle 
                        className={circleColor}
                        strokeWidth="8"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        strokeLinecap="round"
                        stroke="currentColor"
                        fill="transparent"
                        r={radius}
                        cx="50%"
                        cy="50%"
                    />
                </svg>
                <span className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-xl font-bold text-gray-800">
                    {porcentagem}%
                </span>
            </div>

            <p className="text-5xl font-extrabold mb-1" style={{ color: '#3b82f6' }}>
                {diasRestantes}
            </p>
            <p className="text-base text-gray-500 uppercase tracking-wider">
                {diasRestantes === 1 ? 'Dia Restante' : 'Dias Restantes'}
            </p>
            
            {status === 'Concluído' && (
                <p className="text-sm font-bold mt-2 text-green-600">
                    Concluído em {new Date(data_final + 'T12:00:00Z').toLocaleDateString('pt-BR')}
                </p>
            )}
        </div>
    );
};